import _ from 'lodash';
import classnames from 'classnames';
import moment from 'moment';
import ImmutablePropTypes from 'react-immutable-proptypes';
import React from 'react';
import PropTypes from 'prop-types';

import Conversation from 'models/conversation';
import RelativeDateTime from '../../lib/date/relative_date_time';
import ShortList from 'components/common/short_list';

export default function ConversationHeader({
  conversation,
  assignedAgent,
  isActive,
  lastItemTimestamp,
  topics,
  topicsLong,
  onSlaClick,
}) {
  if (!conversation) {
    return <div className="conversationHeader-empty" />;
  }
  let content = null;

  let topicDisplay = (
    <ShortList className="conversationHeader-topic" placeholder="No Topic" values={topics} tooltipValues={topicsLong} />
  );

  if (conversation.status === Conversation.Status.CLOSED) {
    const agentName = assignedAgent ? assignedAgent.name : 'An agent';
    const lastWorkDate = lastItemTimestamp || conversation.createdAt;
    const formattedDate = moment(lastWorkDate).format('MMM D, YYYY');

    content = (
      <div className="conversationHeader-content conversationHeader-closed">
        {agentName}
        {` worked on\xa0`}
        {topicDisplay}
        {`\xa0on `}
        {formattedDate}
      </div>
    );
  } else {
    const formattedDate = moment(conversation.createdAt).format('MMM D');
    let shouldShowSeparator =
      (conversation.sla && conversation.sla.dueAt) || conversation.status === Conversation.Status.WAITING;

    content = (
      <div className="conversationHeader-content">
        <div className="conversationHeader-date conversationHeader-emphasized">{formattedDate}</div>
        <div className="conversationHeader-separator">•</div>
        <div className="conversationHeader-emphasized conversationHeader-topicWrapper">{topicDisplay}</div>
        {shouldShowSeparator && <div className="conversationHeader-separator">•</div>}
      </div>
    );
  }
  const waitingStatus = (
    <div className="conversationHeader-emphasized conversationHeader-sla conversationHeader-waiting">Waiting</div>
  );
  let conversationId = conversation.id;
  let slaProps = { onSlaClick, conversationId };
  slaProps = _.merge(slaProps, _.pick(conversation.sla, ['dueAt', 'contentType', 'setByConversationItemId']));

  const headerClassNames = classnames('conversationHeader', {
    'conversationHeader-active': isActive,
  });
  return (
    <div className={headerClassNames}>
      <div className="conversationHeader-spacer" />
      {content}
      {conversation.isOpen() && <Sla {...slaProps} />}
      {conversation.status === Conversation.Status.WAITING && waitingStatus}
      <div className="conversationHeader-spacer" />
    </div>
  );
}

ConversationHeader.propTypes = {
  assignedAgent: PropTypes.object,
  conversation: PropTypes.object.isRequired,
  isActive: PropTypes.bool,
  lastItemTimestamp: PropTypes.string,
  topics: ImmutablePropTypes.listOf(PropTypes.string),
  onSlaClick: PropTypes.func,
};

export function Sla({ dueAt, contentType, setByConversationItemId, onSlaClick, conversationId }) {
  if (dueAt) {
    const danger = moment()
      .add(5, 'minutes')
      .isAfter(dueAt);
    const classNames = classnames('conversationHeader-sla', { 'conversationHeader-sla-danger': danger });
    const slaItemMarker = `#conversationItem-${setByConversationItemId}`;
    const onClick = e => {
      e && e.preventDefault();
      onSlaClick(conversationId, setByConversationItemId);
    };

    return (
      <a className={classNames} onClick={onClick} href={slaItemMarker}>
        <span>
          Due <RelativeDateTime timestamp={dueAt} />
        </span>
      </a>
    );
  }

  return null;
}

Sla.propTypes = {
  contentType: PropTypes.string,
  dueAt: PropTypes.string,
  setByConversationItemId: PropTypes.string,
  onSlaClick: PropTypes.func,
  conversationId: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/conversation_history/conversation_header.jsx